import { BsBuildings } from "react-icons/bs";
import { IoStatsChart } from "react-icons/io5";
import { FaCoins, FaCommentDots } from "react-icons/fa6";
import { FaHome, FaUserCog, FaUsers } from "react-icons/fa";
import { MdEngineering } from "react-icons/md";

export const adminLinks = [
	{ label: "Inicio", path: "/inicio", icon: FaHome },
	{ label: "Perfil", path: "/perfil", icon: FaUserCog },
	{ label: "Inmobiliarias", path: "/inmobiliarias", icon: BsBuildings },
	{ label: "Usuarios", path: "/usuarios", icon: FaUsers },
	{ label: "Gastos", path: "/gastos", icon: FaCoins },
	{ label: "Reportes", path: "/reportes", icon: IoStatsChart },
	{ label: "Quejas y reportes", path: "/quejasyreportes", icon: FaCommentDots },
	{ label: "Mantenimiento", path: "/Mantenimiento", icon: MdEngineering },
];